export default "__VITE_ASSET__BY$C8XXS__"